export const FACE_PARAMS = [
  "PupilDilationLeft", "PupilDilationRight",
  "UpperLidRaiserLeft", "UpperLidRaiserRight",
  "LidTightenerLeft", "LidTightenerRight",
  "EyeClosedLeft", "EyeClosedRight",
  "InnerBrowRaiserLeft", "InnerBrowRaiserRight",
  "OuterBrowRaiserLeft", "OuterBrowRaiserRight",
  "BrowLowererLeft", "BrowLowererRight",
  "NoseWrinklerLeft", "NoseWrinklerRight",
  "UpperLipRaiserLeft", "UpperLipRaiserRight",
  "CheekRaiserLeft", "CheekRaiserRight",
  "DimplerLeft", "DimplerRight",
  "LipCornerPullerLeft", "LipCornerPullerRight",
  "LipCornerDepressorLeft", "LipCornerDepressorRight",
  "LowerLipDepressorLeft", "LowerLipDepressorRight",
  "LipStretcherLeft", "LipStretcherRight",
  "LipPressorLeft", "LipPressorRight",
  "LipTightenerLeft", "LipTightenerRight",
  "ChinRaiser",
  "JawDrop", "JawSidewaysLeft", "JawSidewaysRight", "JawThrust",
  "LipSuck", "MouthOpen", "LipFunneler"
]
